import { Box, Container, Typography, Button, Grid } from '@mui/material';
import { useStyles } from './styles';

function PageNotfoundContainer(props) {
  const classes = useStyles();
  return (
    <Container>
      <Box height={'calc(100vh - 75px)'} display={'flex'}>
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
          <Grid>
            <Box component="img" sx={classes.logo} src={`/assets/images/svg/box.svg`} width={175} />
          </Grid>
          <Grid>
            <Box>
              <Typography sx={classes.title}>{`Sorry, tracking ID not found!`}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default PageNotfoundContainer;
